import { useTimer } from 'react-timer-hook';
import {observer} from "mobx-react";
import LoginHandler from "../../functions/login";

function MyTimer({ expiryTimestamp ,divID}) {
  const loginHandler = new LoginHandler();
  const {
    seconds,
    minutes,
    hours,
    days
  } = useTimer({ expiryTimestamp, onExpire: () => loginHandler.resetTimer(divID)} );
    return (
      <>
      {days > 0 && <span>{days}d:</span>}
      <span>{hours}h</span>:<span>{minutes}m</span>:<span>{seconds}s</span>
      </>   );
  }


export default observer(MyTimer);

//0.6498